export default "__VITE_ASSET__G4gY0hpR__"